import { useState } from 'react';
import ContactForm from '../ContactForm/ContactForm';
import Modal from '../Modal/Modal';
import Service from '../../Service';

const formDescription =
	"Let us know you're interested by filling out some information below. You'll be able to talk with a REAL ESTATE PROFESSIONAL about your home's value and your personal real estate goals!";

function Footer(props) {
	const { address, agent, valuationId } = props;
	const service = new Service();
	const [addContactError, setAddContactError] = useState(null);
	const [showContactModal, setShowContactModal] = useState(false);
	const [showContactModalSuccess, setShowContactModalSuccess] =
		useState(false);

	async function _handleOnSubmit(values) {
		const groupId = agent.group?.id ?? null;
		values.address = address;

		try {
			await service.createContact(
				values,
				agent.id,
				valuationId,
				groupId,
				'contactMe'
			);

			setShowContactModal(false);
			setShowContactModalSuccess(true);
		} catch (error) {
			setAddContactError('An unexpected error has occurred.');
		}
	}

	function _handleOnContactClose() {
		setShowContactModal(false);
	}

	function _handleOnContactCloseSuccess() {
		setShowContactModalSuccess(false);
	}

	function renderContactModal() {
		if (showContactModal) {
			return (
				<Modal onClose={_handleOnContactClose}>
					<ContactForm
						addContactError={addContactError}
						alignLeft={true}
						buttonText="Get In Touch"
						description={formDescription}
						heading="Want to talk about your home's valuation report?"
						onSubmit={_handleOnSubmit}
						type="contactMe"
					/>
				</Modal>
			);
		}

		return null;
	}

	function renderContactModalSuccess() {
		if (showContactModalSuccess) {
			return (
				<Modal onCloseSuccess={_handleOnContactCloseSuccess}>
					<section>
						<h1 className="header">Thank you!</h1>
						<p className="my-6">
							Your request has been sent. I'll be in touch with
							you soon!
						</p>
						<footer className="footer">
							<button
								className="button w-full my-4 flex justify-center h-ms-2"
								onClick={() => _handleOnContactCloseSuccess()}
								type="button"
							>
								Confirm
							</button>
						</footer>
					</section>
				</Modal>
			);
		}
	}

	return (
		<footer className="my-6 flex flex-col items-center">
			<p className="mb-2">
				Ready to dive right in and chat about your home’s value
				together?
			</p>
			<button
				className="button mb-6 uppercase w-50"
				onClick={() => setShowContactModal(true)}
				type="button"
			>
				contact me
			</button>
			<p className="mt-6 text-sm">
				The valuations are generated from statistical modeling of
				databases with existing properties to calculate real estate
				values. Speaking with a real estate expert is the best way to
				know the value of your home in today's market.
			</p>
			{renderContactModal()}
			{renderContactModalSuccess()}
		</footer>
	);
}

export default Footer;
